import axios from "axios";
import {ENDPOINTS} from "../../js/api/_config";

export class MinnowServices {
    static getMinnowDAta() {
        return axios({
            method: 'GET',
            url: ENDPOINTS.MINNOW.GET_MINNOW_DATA,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static getServiceBrandTrainingList(parameterURL) {
        return axios({
            method: 'GET',
            url: ENDPOINTS.MINNOW.SERVICE_BRAND_TRAINING_URL + "/" + parameterURL,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static getServiceBrandNewsList(parameterURL, pageName) {
        return axios({
            method: 'GET',
            url: ENDPOINTS.MINNOW.SERVICE_BRAND_NEWS + parameterURL + "&PageName=" + pageName,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static getServiceBrandEventList(parameterURL) {
        return axios({
            method: 'GET',
            url: ENDPOINTS.MINNOW.SERVICE_BRAND_EVENTS_URL + "/" + parameterURL,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }
}
